// Components==============
import { motion } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import { GrowthPortfolioContext } from 'pages/Growth/GrowthPortfolio/GrowthPortfolio';
import React, { useContext } from 'react';
import './Progress.module.scss';
// =========================

const bars = [
  { value: 4, color: 'yellow' },
  { value: 5, color: 'yellow' },
  { value: 2, color: 'red' },
  { value: 9, color: 'green' },
  { value: 3, color: 'red' },
  { value: 7, color: 'green' },
];

const parent = {
  visible: {
    transition: { staggerChildren: 0.1, delayChildren: 0.5 },
  },
  invisible: {},
};

const child = {
  visible: { opacity: 1, y: 0 },
  invisible: { opacity: 0, y: 20 },
};

const framerCard = {
  initial: { rotateY: 0, rotateX: 0 },
  animate: { rotateY: -13, rotateX: -3 },
  whileHover: { rotateY: 0, rotateX: 0 },
  whileTap: { rotateY: 0, scale: 0.97, rotateX: 0 },
};

export default function Progress() {
  const translate = useTranslate();

  const reflections = useRedux((state) =>
    state.reflection?.entities.allIds
      .map((id) => state.reflection?.entities.byId[id])
      .filter((r) => r?.created_by === state.authentication?.user?.id)
  );

  const { setSelected } = useContext(GrowthPortfolioContext);

  return (
    <div styleName="box">
      <div styleName="wrapper">
        <motion.div
          styleName="card"
          {...framerCard}
          onClick={() => setSelected('reflection.terms.progress')}
        >
          <img src="/images/jumping-man.png" alt="jumping-man" />
          <div styleName="left">
            <p>{translate('reflection.amount-of-reflections')}</p>
            <h2>{reflections?.length}</h2>
          </div>
          <motion.div
            styleName="graph"
            variants={parent}
            initial="invisible"
            animate="visible"
          >
            {bars.map((bar, i) => (
              <div styleName=" bar-wrapper" key={i}>
                <motion.div
                  variants={child}
                  styleName={`bar ${bar.color}`}
                  style={{ height: bar.value * 8 }}
                />
                <p>{bar.value}</p>
              </div>
            ))}
          </motion.div>
        </motion.div>
        <h3>{translate('reflection.terms.progress')}</h3>
      </div>
    </div>
  );
}
